import { atom } from "jotai";

import { UpdateSingleSlotBookingInput } from "../../../../components/TransferOwnership/hooks/__generated__/useUpdateSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../stores";
import { updatedGuestRoundsAtom } from "../UpdatedRounds/UpdatedGuestRoundsAtom/UpdatedGuestRoundsAtom";
import { updatedMemberRoundsAtom } from "../UpdatedRounds/UpdatedMemberRoundsAtom/UpdatedMemberRoundsAtom";
import { updatedNewGuestRoundsAtom } from "../UpdatedRounds/UpdatedNewGuestRoundsAtom/UpdatedNewGuestRoundsAtom";

export const updateGolfBookingPayloadAtom =
  atom<UpdateSingleSlotBookingInput | null>((get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const updatedMemberRounds = get(updatedMemberRoundsAtom);
    const updatedGuestRounds = get(updatedGuestRoundsAtom);
    const updatedNewGuestRounds = get(updatedNewGuestRoundsAtom);
    const ownerRound = currentBooking.rounds.find((r) => r.isOwner);
    const ownerClientId = ownerRound?.player?.id;
    const input: UpdateSingleSlotBookingInput = {
      bookingId: currentBooking.id,
      notifyMember: false,
      memberRounds: updatedMemberRounds,
      guestRounds: updatedGuestRounds,
      newGuestRounds: updatedNewGuestRounds,
      ownerClientId: ownerClientId ?? undefined,
    };

    return input;
  });
